import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import type { SamplePitch } from '../outreachTypes';
import { campaignMessages as messages } from './campaignMessages';
import { SAMPLE_KIND_PERSON } from './sampleKindCopy';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import shared from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** One written sample (design outreach-v2 d1): who it is for, the subject, the body, the facts. */
const SamplePitchTextComponent: React.FC<{ sample: SamplePitch }> = ({ sample }) => {
  const intl = useIntl();
  const person = intl.formatMessage(SAMPLE_KIND_PERSON[sample.kind]);
  return (
    <>
      <div className={`${shared.small} ${shared.mono}`} data-testid="sample-to">
        {sample.similarArtist === null
          ? intl.formatMessage(messages.sampleTo, { person })
          : intl.formatMessage(messages.sampleToAdded, { person, artist: sample.similarArtist })}
      </div>
      <div className={shared.msgSubject}>{sample.subject}</div>
      <p className={shared.msgBody}>{sample.body}</p>
      <div className={shared.row}>
        <span className={`${shared.chip} ${shared.chipVio}`}>
          {intl.formatMessage(messages.previewAngle, { angle: sample.angle })}
        </span>
        {sample.factsUsed.length > 0 && (
          <span className={shared.chip}>
            {intl.formatMessage(messages.previewFacts, { facts: sample.factsUsed.join(' · ') })}
          </span>
        )}
      </div>
    </>
  );
};

export const SamplePitchText = TypedMemo(SamplePitchTextComponent);
